import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n)

function loadLocaleMessages() {
    const locales = require.context('./locales', true, /[a-z0-9-_,\s]+\.json$/i)
    const messages = {}
    locales.keys().forEach(key => {
        const matched = key.match(/([a-z0-9-_]+)\./i)
        if (matched && matched.length > 1) {
            const locale = matched[1]
            messages[locale] = locales(key)
        }
    })
    return messages
}

export default new VueI18n({
    locale: process.env.VUE_APP_I18N_LOCALE || 'en',
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
    messages: loadLocaleMessages()
})

// // region 번역 관련
// import {
//     fromJS,
//     Map,
// } from 'immutable';
// import en from './locales/en.json';
// import ko_kr from './locales/ko-kr.json';
// import zh from './locales/zh.json';
// import cs from './locales/cs.json';
//
// /**
//  * 언어코드 (언어 추가시 코드만 추가)
//  * @type {string[]}
//  */
// const header = [
//     'ko',
//     'en',
//     'zh',
//     'cs',
// ];
//
// /**
//  * 전달 받은 문자
//  * 아래 형식으로 만들어서 추가추가추가
//  * ['modal.confirm.changed_service_plan.header','변역본'],
//  * @type {string[][]}
//  */
//
// const word = [
// ];
//
// // region 다른 부분 찾기
// /**
//  * 다른 (한곳에 있고, 다른곳에 없고 등) 부분 찾기
//  */
// function diff() {
//     let fullObj = [];
//     let fullData = {};
//     let emptyData = {};
//
//     const deep = (value, parents, country) => {
//         if (typeof value === 'object') {
//             for (const item in value) {
//                 deep(value[item], `${parents}${parents === '' ? '' : '.'}${item}`, country)
//             }
//         } else {
//             if (!fullObj.includes(parents)) {
//                 fullObj.push(parents);
//                 fullData[parents] = {};
//             }
//
//             fullData[parents][country] = value;
//         }
//     }
//
//     for (let i in arguments) {
//         const country = arguments[i]['country'];
//         deep(arguments[i], '', country);
//     }
//
//     for (const item in fullData) {
//         let empty = false;
//
//         if (Object.keys(fullData[item]).length === header.length) {
//             for (const cItem in fullData[item]) {
//                 if (fullData[item][cItem] === undefined || fullData[item][cItem] === null || fullData[item][cItem] === '' || fullData[item][cItem].replaceAll(' ', '') === '')
//                     empty = true;
//             }
//         } else {
//             empty = true;
//         }
//
//         if (empty) {
//             emptyData[item] = fullData[item];
//         }
//     }
//
//     let rowData = '';
//     for (let key in fullData) {
//         if (fullData.hasOwnProperty(key)) {
//             rowData += `${key}`;
//             for (let i = 0; i < header.length; i++) {
//                 let tempWork = fullData[key][header[i] === 'kr' ? 'ko' : header[i]]
//                 tempWork = tempWork === undefined ? '' : tempWork;
//                 rowData += `|${tempWork.replaceAll('\n', '[enter]')}`;
//             }
//
//             rowData += '\n'
//         }
//     }
//
//     // 전체 데이터
//     console.log(rowData)
//     // 전체 데이터
//     console.table(fullData);
//
//     rowData = '';
//     for (let key in emptyData) {
//         if (emptyData.hasOwnProperty(key)) {
//             rowData += `${key}`;
//             for (let i = 0; i < header.length; i++) {
//                 let tempWork = emptyData[key][header[i] === 'kr' ? 'ko' : header[i]]
//                 tempWork = tempWork === undefined ? '' : tempWork;
//                 rowData += `|${tempWork.replaceAll('\n', '[enter]')}`;
//             }
//
//             rowData += '\n'
//         }
//     }
//
//     // 어느 한곳에는 없는 데이터
//     console.log(rowData)
//     // 어느 한곳에는 없는 데이터
//     console.table(emptyData);
// }
//
// /**
//  * 다른 (한곳에 있고, 다른곳에 없고 등) 부분 찾기
//  * 언어 추가시 뒤에 언어 json 파일 추가
//  */
// diff(ko_kr, en, zh, cs);
// // endregion
// // region excel word to code
// /**
//  * string to obj
//  * @param header
//  * @param word
//  */
// function convert(header, word, lang) {
//     let temp = Map({});
//     temp = temp.set('ko', fromJS(ko_kr));
//     temp = temp.set('en', fromJS(en));
//     temp = temp.set('zh', fromJS(zh));
//     temp = temp.set('cs', fromJS(cs));
//
//     word.map((item) => {
//         temp = temp.updateIn([
//             lang,
//             ...item[0].split('.'),
//         ], () => {
//             return item[1];
//         })
//     })
//
//     console.log(JSON.stringify(temp.get('ko').toJS()));
//     console.log(JSON.stringify(temp.get('en').toJS()));
//     console.log(JSON.stringify(temp.get('zh').toJS()));
//     console.log(JSON.stringify(temp.get('cs').toJS()));
// }
//
// /**
//  * 전달 받은 변역본 사용 가능하도록 변환
//  */
// convert(header, word, 'cs');
// // endregion
// // endregion